module.exports = __webpack_public_path__ + "static/media/4.1fa94c10.svg";